import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistruComponent } from './registru.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { AddRegistruComponent } from './add-registru/add-registru.component';

import { ToateTabelRegistruComponent } from './tabele-registru/toate-tabel-registru/toate-tabel-registru.component';
import { AcordFunctionareComponent } from './tabele-registru/acord-functionare/acord-functionare.component';
import { AutorizatieAlimentatiePublicaComponent } from './tabele-registru/autorizatie-alimentatie-publica/autorizatie-alimentatie-publica.component';
import { AcordTemporarComponent } from './tabele-registru/acord-temporar/acord-temporar.component';
import { AutorizatiePiataComponent } from './tabele-registru/autorizatie-piata/autorizatie-piata.component';
import { AutorizatieRecreativeComponent } from './tabele-registru/autorizatie-recreative/autorizatie-recreative.component';
import { EditOrarComponent } from './edit-orar/edit-orar.component';
import { AddPrelungireComponent } from './add-prelungire/add-prelungire.component';
import { IstoricRegistruComponent } from './istoric-registru/istoric-registru.component';
import { AcordComercializareComponent } from './tabele-registru/acord-comercializare/acord-comercializare.component';
import { AcordTeraseSezoniereComponent } from './tabele-registru/acord-terase-sezoniere/acord-terase-sezoniere.component';
import { EditFieldComponent } from './edit-field/edit-field.component';

@NgModule({
    declarations: [
        RegistruComponent,
        AddRegistruComponent,
        ToateTabelRegistruComponent,
        AcordFunctionareComponent,
        AutorizatieAlimentatiePublicaComponent,
        AcordTemporarComponent,
        AutorizatiePiataComponent,
        AutorizatieRecreativeComponent,
        EditOrarComponent,
        AddPrelungireComponent,
        IstoricRegistruComponent,
        AcordComercializareComponent,
        AcordTeraseSezoniereComponent,
        EditFieldComponent,
    ],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
})
export class RegistruModule { }
